export const coaProps = {
  basename: "/plataforma/consultas/coa",
};
